import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import {
  Settings as BillingSeatsIcon,
  Dashboard as DashboardIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  AccountBalanceWallet as CreditIcon,
  MoneyOff as ExpenseIcon,
  Description as StatementIcon,
  Assessment as ReportIcon,
} from '@mui/icons-material';
import PageLayout from './ui/PageLayout';

const BILLING_TABS = [
  { label: 'Seats', path: '/billing', icon: <BillingSeatsIcon fontSize="small" /> },
  { label: 'Dashboard', path: '/billing/dashboard', icon: <DashboardIcon fontSize="small" /> },
  { label: 'Invoices', path: '/billing/invoices', icon: <ReceiptIcon fontSize="small" /> },
  { label: 'Payments', path: '/billing/payments', icon: <PaymentIcon fontSize="small" /> },
  { label: 'Credits', path: '/billing/credits', icon: <CreditIcon fontSize="small" /> },
  { label: 'Expenses', path: '/billing/expenses', icon: <ExpenseIcon fontSize="small" /> },
  { label: 'Statements', path: '/billing/statements', icon: <StatementIcon fontSize="small" /> },
  { label: 'Reports', path: '/billing/reports', icon: <ReportIcon fontSize="small" /> },
];

const getTabIndex = (pathname) => {
  if (pathname === '/billing' || pathname === '/billing/') return 0;
  if (pathname.includes('/dashboard')) return 1;
  if (pathname.includes('/invoices')) return 2;
  if (pathname.includes('/payments')) return 3;
  if (pathname.includes('/credits')) return 4;
  if (pathname.includes('/expenses')) return 5;
  if (pathname.includes('/statements')) return 6;
  if (pathname.includes('/reports')) return 7;
  return 0;
};

// Note: Index 0 = Seats (PlatformBilling at /billing)
// Tabs shifted by 1 from previous version

const BillingLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tabIndex = getTabIndex(location.pathname);

  const handleTabChange = (_, newValue) => {
    const tab = BILLING_TABS[newValue];
    if (tab) navigate(tab.path);
  };

  return (
    <PageLayout
      padding={0}
      chromePadding={3}
      chromeSx={{ borderBottom: 'none', bgcolor: 'background.default' }}
      sx={{ overflow: 'hidden' }}
    >
      {/* Horizontal sub-tabs - only show on main billing pages (not create flows) */}
      {!location.pathname.includes('/create') && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', px: 3 }}>
          <Tabs
            value={Math.min(tabIndex, BILLING_TABS.length - 1)}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 48,
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, fontSize: '0.875rem' },
            }}
          >
            {BILLING_TABS.map((tab) => (
              <Tab
                key={tab.path}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
              />
            ))}
          </Tabs>
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'auto', p: 3, maxWidth: 1400, mx: 'auto', width: '100%' }}>
        <Outlet />
      </Box>
    </PageLayout>
  );
};

export default BillingLayout;
